import utilidadesService from "../services/utilidades.service";

const initialState = { 
};

export const utilidades = {
  namespaced: true,
  state: initialState,
  actions: {
    async detalleEscaneoFactura(context, object) {
      return await utilidadesService.detalleEscaneoFactura(object);
    },
    async cargaEscaneoFacturas(context, { formData, onProgress, signal }) {
      return await utilidadesService.uploadEscaneoFactura(formData, onProgress, signal);
    },
    async validaDatoFactura(context, object) {
      return await utilidadesService.validaDatoFactura(object);
    },
    async finalizaEscaneoFactura(context, object) {
      return await utilidadesService.finalizaEscaneoFactura(object);
    },
    async borraEscaneoFactura(context, object) {
      return await utilidadesService.borraEscaneoFactura(object);
    }
  },

  mutations: {
  },

  getters: {
  },
};
